import { Card } from '../../components/ui';
import { useAuth } from '../../context/AuthContext';

export function BillingPage() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl">Billing</h1>

      <Card className="p-5 space-y-2">
        <div>
          <span className="text-ink-muted">Current plan:</span>{' '}
          <span className="font-medium">{user?.org.planTier ?? '—'}</span>
        </div>
        <p className="text-ink-muted text-sm">
          TODO(section-7): wire to GET /admin/billing endpoints — show current plan, members cap, SMS cap, next invoice,
          and the Stripe Checkout / Customer Portal buttons.
        </p>
      </Card>
    </div>
  );
}
